import { FC } from 'react'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import About from './components/About'
import Services from './components/Services'
import Gallery from './components/Gallery'
import Philosophy from './components/Philosophy'
import Treatments from './components/Treatments'
import Contact from './components/Contact'
import Footer from './components/Footer'
import SEO from './components/SEO'

const App: FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Gallery />
        <Philosophy />
        <Treatments />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}

export default App
